var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83.817a.847.847 0 011.208 0 .853.853 0 010 1.197L2.906 8.146h20.236c.471 0 .859.375.859.847a.862.862 0 01-.86.859H2.907l6.132 6.12a.868.868 0 010 1.21.847.847 0 01-1.209 0L.245 9.598a.853.853 0 010-1.197L7.83.817z",
    fill: "#72737A"
  })));
}
export default SvgArrowBack;